module.exports = __webpack_public_path__ + "7fc130d03ef6f5fd300c964397839e1b.png";